import { getDistributor, Locale } from '@raisin/cp-utils';
import { createAsyncAction, METHODS } from 'api';
import { MICROSERVICES_NAMES } from 'api/types';
import { getDistributionChannelId } from 'utils/getDistributionChannel';

interface ParamsProps {
  distributor_id: string;
  distribution_channel_id: string;
  include_compliance: boolean;
  bank_ids?: string;
}

const fetchPublicProducts = async ({
  locale,
  bankIds,
  headerId,
}: {
  locale: Locale;
  bankIds?: string[];
  headerId?: string;
}) => {
  try {
    let params: ParamsProps = {
      distributor_id: getDistributor(),
      distribution_channel_id: getDistributionChannelId(locale),
      include_compliance: true,
    };

    if (bankIds?.length) {
      params.bank_ids = bankIds.join(',');
    }

    const headers = headerId ? { 'Request-Source-Tag': headerId } : undefined;

    const settings = { params, headers };

    const products = await createAsyncAction(
      locale,
      MICROSERVICES_NAMES.DBS,
      'dbs.products',
      METHODS.GET,
      settings,
    );
    return products;
  } catch (error) {
    console.log("Can't fetch public products data. ");
    return;
  }
};
export default fetchPublicProducts;
